import { getLocalAccessToken } from "../utils/helper";
import api from "../services/api";
import { Toast } from "../components/notify/Notify";
import { url } from "../constants/path";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.profileDevice;

export const getProfileDevice = (params = {}, callback) => {
  api
    .get(`${url.releaseGroup}${URL}`, { params })
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};
